import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import hybrid from "@/utils/hybrid.js";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
    meta: {
      title: '充值提现'
    }
  },
  { // 登录
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
    meta: {
      title: '登录'
    }
  },
  { // 充值
    path: '/recharge',
    name: 'Recharge',
    component: () => import('../views/RechargeView.vue'),
    meta: {
      title: '充值'
    }
  },
  { // 提现
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('../views/WithdrawalView.vue'),
    meta: {
      title: '提现'
    }
  },
  { // 提现信息
    path: '/withdrawalInfo',
    name: 'WithdrawalInfo',
    component: () => import('../views/WithdrawalInfo.vue'),
    meta: {
      title: '提现信息'
    }
  },  { // 提现信息
    path: '/withdrawalData',
    name: 'withdrawalData',
    component: () => import('../views/WithdrawalData.vue'),
    meta: {
      title: '提现信息'
    }
  },
  { // 绑定提现账户
    path: '/account',
    name: 'Account',
    component: () => import('../views/AccountView.vue'),
    meta: {
      title: '绑定提现账户'
    }
  },{ // 绑定支付宝
    path: '/BindAiLiPay',
    name: 'BindAiLiPay',
    component: () => import('../views/BindAiLiPay.vue'),
    meta: {
      title: '绑定支付宝'
    }
  },
  { // 提现记录
    path: '/withdrawalRecord',
    name: 'WithdrawalRecord',
    component: () => import('../views/WithdrawalRecord.vue'),
    meta: {
      title: '提现记录'
    }
  },
  { // 提现规则
    path: '/withdrawalrules',
    name: 'WithdrawalRules',
    component: () => import('../views/WithdrawalRules.vue'),
    meta: {
      title: '提现说明'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to) => {
  if (hybrid.isValid) {
    if (!sessionStorage.getItem("token") && to.name !== 'Home') {
      return { name: 'Home' }
    }
  } else {
    if (!sessionStorage.getItem("token") && to.name !== 'Login' && to.name !== 'Home') {
      return { name: 'Home' }
    }
  }
})

router.afterEach(() => {
  if (!window.sessionStorage.firstUrl) {
    window.sessionStorage.firstUrl = window.location.href
  }
})

export default router
